import React from 'react';

interface ChartSkeletonProps {
  height?: string;
  className?: string;
}

const ChartSkeleton: React.FC<ChartSkeletonProps> = ({ height = 'h-40', className = '' }) => {
  return (
    <div className={`animate-pulse bg-gray-200 rounded-lg ${height} w-full ${className}`}>
      <div className="h-4 bg-gray-300 rounded w-3/4 mx-auto mt-3"></div>
      <div className="flex justify-center items-center h-[calc(100%-20px)]">
        <div className="h-24 w-24 bg-gray-300 rounded-full"></div>
      </div>
    </div>
  );
};

export default ChartSkeleton;
